import { CHANGE_FONT_SIZE } from './../actions/types';

const initialState = {
    fontSize: `normal`,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_FONT_SIZE:
            return {
                ...state, 
                fontSize: action.fontSize,
            };
        default:
            return state;
    }
};